const comparisons = [
  {
    feature: "Processing Time",
    fpc: "24 hours – 3 weeks (your choice)",
    agency: "Appointment only; 1–8 weeks",
    winner: "fpc",
  },
  {
    feature: "Appointment Needed",
    fpc: "No. Start online immediately.",
    agency: "Yes. Limited slots, often booked 2+ weeks out.",
    winner: "fpc",
  },
  {
    feature: "Wait in Line",
    fpc: "No lines. Courier handles everything.",
    agency: "Yes. Arrive early, plan for hours.",
    winner: "fpc",
  },
  {
    feature: "Document Review",
    fpc: "Expert pre-check included. Catch errors before submission.",
    agency: "Limited. Errors = rejection and delay.",
    winner: "fpc",
  },
  {
    feature: "Photo Services",
    fpc: "Guidance + local photo partner network.",
    agency: "Bring your own or use agency photo services.",
    winner: "tie",
  },
  {
    feature: "Track Progress",
    fpc: "Real-time tracking + human support.",
    agency: "Limited status updates.",
    winner: "fpc",
  },
  {
    feature: "Return Shipping",
    fpc: "Secure overnight return to your Estero address.",
    agency: "Standard mail or optional overnight.",
    winner: "fpc",
  },
  {
    feature: "Distance from Estero",
    fpc: "Remote service — no travel required.",
    agency: "~120+ miles via I-75 / Alligator Alley",
    winner: "fpc",
  },
];

export default function EsteroComparisonSection() {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-[#B22222] text-xs font-bold uppercase tracking-[0.15em] mb-3">
            Comparison
          </span>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Fast Passport Center vs. Miami Passport Agency
          </h2>
          <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            The Miami Passport Agency is the closest regional agency to Estero — but it is over 120 miles away via I-75 and Alligator Alley. Here is how we compare.
          </p>
        </div>

        <div className="bg-amber-50 border border-[#F6C344]/40 rounded-lg p-5 md:p-6 mb-8">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <div className="flex-1">
              <h3 className="font-bold text-base text-[#1A365D] mb-1">Passport Agency Appointment Not Available?</h3>
              <p className="text-sm text-gray-600">Don't let a booked-out agency appointment block your travel plans. We bypass the agency bottleneck with reserved daily courier slots — faster and no appointment roulette.</p>
            </div>
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
            >
              Get Started <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b-2 border-[#1A365D]">
                <th className="text-left py-4 px-4 font-serif text-[#1A365D] font-bold">Feature</th>
                <th className="text-left py-4 px-4 font-semibold text-[#F6C344] bg-[#1A365D] rounded-t-lg">
                  <i className="ri-star-fill mr-1"></i>
                  Fast Passport Center
                </th>
                <th className="text-left py-4 px-4 font-semibold text-gray-500">
                  Miami Passport Agency
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisons.map((row, i) => (
                <tr
                  key={i}
                  className={`border-b border-gray-100 ${i % 2 === 0 ? "bg-[#F8F9FB]/50" : ""}`}
                >
                  <td className="py-4 px-4 font-medium text-[#1A365D]">{row.feature}</td>
                  <td className="py-4 px-4 text-gray-700">
                    <span className="inline-flex items-center gap-1.5">
                      {row.winner === "fpc" && (
                        <i className="ri-checkbox-circle-fill text-emerald-500 text-xs"></i>
                      )}
                      {row.fpc}
                    </span>
                  </td>
                  <td className="py-4 px-4 text-gray-500">{row.agency}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-8 text-center">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-8 py-3 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Start with Fast Passport Center <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}